import { Navigate, Outlet, useLocation } from 'react-router-dom';
import AppLoaderComponent from 'component/global/app-core/app-loader/app-loader-component';
import { useAuth } from 'app/providers/AuthProvider';
import { buildPublicLoginPath, useLoginGatePage } from 'app/services/auth/loginRedirect';

const PrivateRouteGuard = () => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    const { data: loginGatePage, isLoading: isLoginGatePageLoading } = useLoginGatePage();

    if (isLoading || (!isAuthenticated && isLoginGatePageLoading)) {
        return <AppLoaderComponent />;
    }

    if (!isAuthenticated) {
        const returnTo = `${location.pathname}${location.search}${location.hash}`;
        return <Navigate to={buildPublicLoginPath(loginGatePage, returnTo)} replace />;
    }

    return <Outlet />;
};


export default PrivateRouteGuard;
